<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <BranchRoleForm
      v-if="!isLoading"
      :branchRoleData="branchRoleData"
      :submitName="$t('add')"
      v-on:addOrUpdateBranchRole="addOrUpdateBranchRole"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import BranchRoleForm from "@/components/settings/settingsOther/branchRoles/BranchRoleForm.vue";
import BranchRole from "@/models/settings/settingsOther/branchRoles/BranchRole";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "BranchRoleAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    BranchRoleForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      branchRoleData: new BranchRole(),
    };
  },
  methods: {
    async addOrUpdateBranchRole() {
      this.isLoading = true;
      try {
        let response = await this.branchRoleData.addOrUpdateBranchRole(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.branchRoleData.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {},
};
</script>

<style scoped lang="scss"></style>
